import type {HelixSeriesListQueryVariables} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * Helix 도메인 Query Key 관리
 */
export const HELIX_QUERY_KEY_MAP = {
  /**
   * Helix 시리즈 목록 조회
   * Origin: useHelixSeriesListQuery.getKey
   */
  seriesList: (variables: HelixSeriesListQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'helixSeriesList', variables] as const,
} as const;
